import type { ThunkDispatch, UnifiedGroup } from '../../../../shared';
import {
    restoreGroupClickedAction,
    restoreGroupThunk,
} from '../../data/groups/unifiedGroupActions';
import {
    favoriteGroupClickedAction,
    unFavoriteGroupClickedAction,
    toggleFavoriteGroup,
} from '../../data/groups/favoriteGroupActions';
import {
    followGroupClickedAction,
    unFollowGroupClickedAction,
    toggleFollowGroup,
} from '../../data/groups/followGroupActions';
import { leaveGroupClickedAction } from '../../data/groups/leaveGroupActions';
import {
    exportUnifiedGroupClickedAction,
    getExportUnifiedGroupStatus,
} from '../../data/groups/exportGroupActions';
import { GroupOperationSource } from '../../../models/unifiedGroupOperation';
import { renewGroupClickedAction, renewGroupAction } from '../../data/groups/renewGroupActions';
import { joinGroupClickedAction, joinGroupCompleted } from '../../data/groups/joinGroupActions';

export const commandBarToggleFavoriteGroup = (dispatch: ThunkDispatch) => (
    groupId: string,
    groupName: string,
    isFavorite: boolean,
    hubPersonaId: string,
    groupSmtp: string
) => {
    dispatch(
        isFavorite
            ? unFavoriteGroupClickedAction({ groupId: groupId, hubPersonaId })
            : favoriteGroupClickedAction({ groupId: groupId, hubPersonaId })
    );
    toggleFavoriteGroup(dispatch)(groupId, groupName, isFavorite, hubPersonaId, groupSmtp);
};

export const commandBarToggleFollowGroup = (dispatch: ThunkDispatch) => (
    groupSmtp: string,
    groupId: string,
    groupName: string,
    isFollowed: boolean,
    hubPersonaId: string
) => {
    dispatch(
        isFollowed
            ? unFollowGroupClickedAction({ groupId, hubPersonaId })
            : followGroupClickedAction({ groupId, hubPersonaId })
    );
    toggleFollowGroup(dispatch)(groupSmtp, groupId, groupName, isFollowed, hubPersonaId);
};

export const commandBarLeaveGroup = (dispatch: ThunkDispatch) => (
    groupId: string,
    isLastOwner: boolean,
    groupKind: number,
    leaveGroupForFamilyUrl: string
) => {
    dispatch(leaveGroupClickedAction({ groupId, isLastOwner, groupKind }));
    if (groupKind == 3) {
        window.open(leaveGroupForFamilyUrl);
    }
};

export const commandBarExportGroup = (dispatch: ThunkDispatch) => (group: UnifiedGroup) => {
    getExportUnifiedGroupStatus(
        dispatch,
        group.externalDirectoryObjectId,
        group.emailAddress,
        group.hubPersonaId
    );

    dispatch(exportUnifiedGroupClickedAction({ group }));
};

export const commandBarJoinGroup = (dispatch: ThunkDispatch) => (
    group: UnifiedGroup,
    userEmailAddress: string
) => {
    dispatch(joinGroupClickedAction({ group }));
    dispatch(joinGroupCompleted(group, userEmailAddress));
};

export const commandBarRestoreGroup = (dispatch: ThunkDispatch) => (
    groupId: string,
    groupSmtp: string,
    groupName: string,
    hubPersonaId: string,
    routingKey: string
) => {
    dispatch(
        restoreGroupClickedAction({
            groupId,
            source: GroupOperationSource.Commandbar,
            hubPersonaId,
        })
    );
    dispatch(restoreGroupThunk(groupId, groupSmtp, groupName, hubPersonaId, routingKey));
};

export const commandBarRenewGroup = (dispatch: ThunkDispatch) => (
    groupId: string,
    groupSmtp: string,
    groupName: string,
    hubPersonaId: string
) => {
    dispatch(renewGroupClickedAction({ groupId, hubPersonaId }));
    renewGroupAction(dispatch)(groupId, groupSmtp, groupName, hubPersonaId);
};
